import DestinationsSide from './styled';

export default DestinationsSide;
